import { apiClient } from '@abaninja/util-http-client';

export function addSupportUser() {
  return apiClient.post('/users/v1/support');
}

export function removeSupportUser() {
  return apiClient.delete('/users/v1/support');
}
